"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClusterUiError = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_core_1 = require("@patternfly/react-core");
const common_1 = require("../../../common");
const BackButton_1 = require("../ui/Buttons/BackButton");
const ClusterUiError = () => (react_1.default.createElement(react_core_1.PageSection, { variant: react_core_1.PageSectionVariants.light, isFilled: true },
    react_1.default.createElement(common_1.ErrorState, { title: "Failed to retrieve the default configuration", actions: [react_1.default.createElement(BackButton_1.BackButton, { key: 'cancel', to: '..' })] })));
exports.ClusterUiError = ClusterUiError;
//# sourceMappingURL=ClusterPageErrors.js.map